
import {
  addStay,
} from '@/api/stay';
import { parseConcatNumber } from '@/utils/filters';
import { ElForm } from 'element-ui/types/form';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class extends Vue {
  private form: any = {
    idx: '',
    periodDate: '',
    periodTime: '',
    fee: '',
    description: '',
  }

  private cancelIdx = this.$route.params.idx;

  private loading = false;

  private rules = {
    periodDate: [
      { required: true, message: '기간(일수)을 입력하세요.', trigger: ['change', 'blur'] },
    ],
    periodTime: [
      { required: true, message: '기간(시간)을 선택하세요.', trigger: ['change', 'blur'] },
    ],
    fee: [
      { required: true, message: '수수료를 입력하세요.', trigger: ['change', 'blur'] },
    ],
    description: [
      { required: true, message: '설명을 입력하세요.', trigger: ['blur', 'change'] },
    ],
  }

  private handleClickSave() {
    (this.$refs.cancelForm as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.$confirm(`정말 해당 설정을 ${this.cancelIdx ? '수정' : '등록'} 하시겠습니까?`, `설정 ${this.cancelIdx ? '수정' : '등록'}`, {
          confirmButtonText: `${this.cancelIdx ? '수정' : '등록'}`,
          cancelButtonText: '취소',
          type: 'info',
        }).then(() => {
          this.$message.success('설정이 등록되었습니다.');
          this.$router.push({ name: 'Cancel' });
        });
      }
    });
  }

  private handleClickCancel() {
    this.$router.push({ name: 'Cancel' });
  }
}
